import VueRouter, { RouteConfig } from 'vue-router'

const Create = () => import('../views/summer-2022/Create.vue')
const List = () => import('../views/summer-2022/List.vue')
const Detail = () => import('../views/summer-2022/Detail.vue')
const Landing = () => import('../views/summer-2022/Landing.vue')
const Statistics = () => import('@/views/summer-2022/Statistics.vue')

export const createRoute: RouteConfig = {
  path: '/summer2022-vacation-homework/create',
  name: 'summer2022_vacation_homework_create',
  component: Create,
  props: (route) => {
    return { ...route.query }
  },
}

export const listRoute: RouteConfig = {
  path: '/summer2022-vacation-homework/list',
  name: 'summer2022_vacation_homework_list',
  component: List,
  meta: {
    title: '2022暑假作业',
  },
}

export const detailRoute: RouteConfig = {
  path: '/summer2022-vacation-homework/detail',
  name: 'summer2022_vacation_homework_detail',
  component: Detail,
  props: (route) => {
    return { ...route.query }
  },
}

export const landingRoute: RouteConfig = {
  path: '/summer-vacation-2022-landing',
  name: 'summer_vacation_2022_landing',
  component: Landing,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '2022暑假作业',
  },
}

export const statisticsRoute: RouteConfig = {
  path: '/summer2022-vacation-homework/statistics',
  name: 'summer2022_vacation_homework_statistics',
  component: Statistics,
  meta: {
    title: '2022暑假作业',
  },
}

export const Summer2022Routes = [createRoute, listRoute, detailRoute, landingRoute, statisticsRoute]

export function navigateToSummerVacation2022List(router: VueRouter) {
  router.push({ name: listRoute.name })
}

export function navigateToSummerVacation2022Edit(router: VueRouter) {
  router.push({ name: createRoute.name })
}

export function navigateToSummerVacation2022Landing(router: VueRouter, qd?: string) {
  router.push({ name: landingRoute.name, query: { qd } })
}

export function redirectToSummerVacation2022Landing(router: VueRouter) {
  router.replace({ name: landingRoute.name })
}
